// extracted by mini-css-extract-plugin
module.exports = {"link":"stylesNav_link__1m_kg","activeLink":"stylesNav_activeLink__5CkCD"};